var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 1.108c.273.252.273.659 0 .887L4.72 9.07c-.228.274-.636.274-.887 0L.188 5.425c-.25-.228-.25-.635 0-.887a.647.647 0 01.91 0l3.19 3.192 6.62-6.622c.252-.25.66-.25.887 0z",
    fill: "#093545"
  })));
}

export default SvgIconCheck;